var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityThread } from './entity-thread';
import { useLang } from '../hooks/use-lang';
import { useActivePerson } from '../hooks/use-active-person';
import { animateScroll as scroll } from 'react-scroll';
import { NoResultsLayout } from '../elements/no-results-layout';
import { useView } from '../hooks/use-view';
var cls = classNames('community-request-threads');
export var CommunityRequestThreadsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: scroll;\n    padding-top: ", ";\n    \n  "], ["\n    position: relative;\n    overflow: scroll;\n    padding-top: ", ";\n    \n  "])), theme.UNIT(12))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  "])))
});
var ThreadsListStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n  "], ["\n    height: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n  "])))
});
var ThreadStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'CommunityRequestThreads',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ThreadsList: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ThreadsListStyles),
  Thread: styled(EntityThread)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ThreadStyles)
};
export var CommunityRequestThreads = function (props) {
  var _a = useComponentProps(My.NAME, CommunityRequestThreadsDefaultProps, props),
    className = _a.className,
    children = _a.children,
    loading = _a.loading,
    onEditRequest = _a.onEditRequest,
    onDeleteRequest = _a.onDeleteRequest,
    _b = _a.items,
    items = _b === void 0 ? [] : _b;
  var t = useLang();
  var activeSubView = useView('conversations', 'conversations', 'all-items').activeSubView;
  var anchorName = "community-request-threads";
  var hasItems = !!items.length;
  var isEmpty = !loading && !items.length;
  var isAllItemsView = activeSubView === 'all-items';
  var person = useActivePerson().person;
  var requestCount = items.length;
  var prevCommentsLength = useRef(requestCount);
  var scrollableAreaRef = useRef(null);
  React.useEffect(function () {
    if (requestCount > prevCommentsLength.current) {
      scroll.scrollToTop({
        containerId: anchorName,
        duration: 300,
        smooth: true
      });
    }
    prevCommentsLength.current = requestCount;
  }, [items, anchorName, activeSubView]);
  return React.createElement(My.Container, {
    className: cls.name(className),
    ref: scrollableAreaRef,
    id: anchorName
  }, React.createElement(My.Body, null, React.createElement(My.ThreadsList, null, hasItems ? items.map(function (request, index) {
    return React.createElement(My.Thread, {
      key: "community-request-".concat(request.id, "-").concat(index),
      entity: request,
      canEdit: (person === null || person === void 0 ? void 0 : person.id) === request.createdBy.id,
      canDelete: (person === null || person === void 0 ? void 0 : person.id) === request.createdBy.id,
      onEdit: onEditRequest ? function () {
        return onEditRequest(request);
      } : undefined,
      onDelete: onDeleteRequest ? function () {
        return onDeleteRequest(request);
      } : undefined
    });
  }) : isAllItemsView ? React.createElement(NoResultsLayout, {
    title: 'Submit a Bulletin to start Collaborating'
  }) : React.createElement(NoResultsLayout, null), children)));
};
CommunityRequestThreads.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;